export enum CANCELED_OPTIONS {
  CUSTOMER = 'CUSTOMER',
  DECLINED = 'DECLINED',
  FRAUD = 'FRAUD',
  INVENTORY = 'INVENTORY',
  OTHER= 'OTHER'
}

export const CANCELED_REASONS: Map<CANCELED_OPTIONS, string> = new Map();
CANCELED_REASONS.set(CANCELED_OPTIONS.CUSTOMER, 'Customer changed/cancelled order');
CANCELED_REASONS.set(CANCELED_OPTIONS.DECLINED, 'Payment was declined');
CANCELED_REASONS.set(CANCELED_OPTIONS.FRAUD, 'Order was fraudulent');
CANCELED_REASONS.set(CANCELED_OPTIONS.INVENTORY, 'Items were out of stock');
CANCELED_REASONS.set(CANCELED_OPTIONS.OTHER, 'The order was canceled for an unlisted reason');
